<template>
    <c-sidebar-brand>
        <slot />
    </c-sidebar-brand>
</template>
<script setup>
import { CSidebarBrand } from '@coreui/vue/dist/esm/components/sidebar/index.js';
</script>
